module.exports = __webpack_public_path__ + "static/img/2826_phase_function_Paper_Points.6cff76f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2826_phase_function_Paper_Points.png
// module id = 9XFj
// module chunks = 0